import { createChartStore } from '../components/chart/store/store';
export const createChartStoresSlice = (set) => ({
    chartStores: {},
    addChart: (id) => {
        const store = createChartStore({ chartId: id }); //repopulate chart store from local storage
        set((state) => ({
            chartStores: {
                ...state.chartStores,
                [id]: store,
            },
        }));
        return store;
    },
    removeChart: (id) => set((state) => {
        const storesCopy = { ...state.chartStores };
        delete storesCopy[id];
        return {
            chartStores: storesCopy,
        };
    }),
});
